/** Staging (30 Oct 2026): every page says it is the test copy, and where its data came from. */
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

type Options = { env?: 'staging'; stageData?: { copiedAt: string; days: number } | null };

export function StagingBanner() {
  const opts = useQuery({
    queryKey: ['auth-options'],
    queryFn: () => api<Options>('/api/auth/options'),
    staleTime: Infinity,
  });
  if (opts.data?.env !== 'staging') return null;
  const d = opts.data.stageData;
  const when = d
    ? new Date(d.copiedAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', timeZone: 'Asia/Karachi' })
    : null;
  return (
    <div className="stagebar" role="note">
      <b>Staging</b>
      <span className="stagebar-long">
        A test copy: nothing here reaches anyone or changes the real Task Force.
        {when ? ` Data from production on ${when} (last ${d!.days} days), names and emails scrambled.` : ''}
      </span>
      <span className="stagebar-short">Test copy: nothing here reaches anyone{when ? ` · data of ${when}` : ''}</span>
    </div>
  );
}
